(function() { window.GUID_26d8d447_24da_48c4_9ad0_6f05b894ce31 = { getGuid: function() { return "26d8d447-24da-48c4-9ad0-6f05b894ce31"; } }; })();
jQuery.fn.extend({
    offon: function (events, selector, handler) {
        var splitBySpace = events.split(' ');
        $.each(splitBySpace, function (i, element) {
            if (element.indexOf(".") == -1) {
                throw 'A namespace for event ' + element + ' is missing!!!!';
            }
        });
        this.off(events).on(events, selector, handler);
        return this;
    },
    disableSelection: function () {
        return this
            .attr('unselectable', 'on')
            .css('user-select', 'none')
            .on('selectstart', false);
    },
    scrollTo: function (target, duration, basedOnRelativePosition, scrollOffset) {
        if (target != null && target.length > 0) {
            if (duration == null) {
                duration = 250;
            }
            var offset = 0;
            if (scrollOffset != null) {
                offset = scrollOffset;
            }
            if (basedOnRelativePosition != null && basedOnRelativePosition) {
                this.animate({ scrollTop: $(this).scrollTop() + target.position().top + offset }, duration);
            }
            else {
                this.animate({ scrollTop: $(this).scrollTop() + target.offset().top + offset }, duration);
            }
        }
    }
});
//# sourceMappingURL=jquery.extensions.js.map
//# sourceMappingURL=jquery.extensions.js.map
